import { redirectUnauthedUser } from './redirectUnauthedUser';

// Web refresh tokens only live 12 hours, so a dispatch tab left open past
// that starts failing every request; this self-heals the tab instead of
// leaving it broken until someone reloads it.
//
// The delay is a grace period for a concurrent sign-out: another tab's
// sign-out clears tokens from localStorage before its /logout navigation
// clears the Hosted-UI cookie, and redirecting inside that window could
// silently re-auth off the still-live cookie and resurrect the session the
// user just ended (BAM-548 class). After the delay the cookie is gone and
// the tab lands on the login page.
export const EXPIRED_SESSION_REDIRECT_DELAY_MS = 5_000;

let latched = false;

export function scheduleExpiredSessionRedirect(): void {
  if (latched) return;
  // Never unlatched: re-triggering while the redirect navigation is in
  // flight would start competing redirects.
  latched = true;
  setTimeout(() => {
    void redirectUnauthedUser();
  }, EXPIRED_SESSION_REDIRECT_DELAY_MS);
}
